import {observer} from "mobx-react";
import React from "react";
import FontBody1 from "../../../components/fonts/font-body1/font-body1";
import {FONT_COLOR, FONT_VARIANT} from "../../../components/fonts/font-props";
import Card from "../../../components/layouts/card/card";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import './rma-automation-card.scss';
import CreateRmaSessionStore from "../stores/create-rma-session-store";
import { IValidationGroup } from "../../../hooks/validation-group/validation-group-hook";
import RMAAutomationSection from "./rma-automation-section";

interface IProps {
	sessionStore: CreateRmaSessionStore;
	validationGroup: IValidationGroup;
}

const RMAAutomationCard: React.FC<IProps> = observer(({ sessionStore, validationGroup }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';
    
	return (
		<div className='rma-automation-card'>
			<Card isExpandable={true}
			      toolbar={{title: <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('AUTOMATIONS', pageScope)}</FontBody1>}}>
				<RMAAutomationSection sessionStore={sessionStore} validationGroup={validationGroup} />
			</Card>
		</div>
	)
});

export default RMAAutomationCard;
